import initDatadog from "./src/components/utils/Datadog";
import { initAmplitude } from "./src/components/utils/Amplitude";

export const wrapRootElement = ({ element }) => {
  initDatadog();
  initAmplitude();
  return element;
};
